import type { VoidFunctionComponent } from 'react';
import { Helmet } from 'react-helmet';
import { useSynchronizeSubscription } from '../../../hooks/subscriptions/useSynchronizeSubscription';
import { useOnMount } from '../../../hooks';
import Card from '../../generic/Card/Card';
import Loader from '../../generic/Loader';
import { useRouter } from '../../../contexts/RouterContext';

/**
 * This page is just a landing page for Stripe checkout sessions.
 * It ensures the org subscription is synchronized with Stripe before redirecting to the
 * new plans page.
 */
const PlanUpdateCallback: VoidFunctionComponent = () => {
  const {
    mutate: synchronizeSubscription,
    isSuccess: hasSynchronized,
  } = useSynchronizeSubscription();

  useOnMount(synchronizeSubscription);

  const router = useRouter();

  if (hasSynchronized) {
    router.replace('/account/settings/billing/wip?tab=Plans&update_success=true');
  }

  return (
    <div className="container margin-top">
      <Helmet title="Subscription" />
      <Card isFullWidth>
        <Card.Header>
          <h1>Subscription</h1>
        </Card.Header>
        <Card.Content>
          <h1>Loading...</h1>
          <Loader />
        </Card.Content>
      </Card>
    </div>
  );
};

export default PlanUpdateCallback;
